import { BudgetSahPreview } from '~support-at-home/actions/budgets';

export type MatchType = 'auto' | 'choose' | 'no-match';

// Categorises a budget by its SAH candidates: exactly one → auto-match, several → user
// must choose, none → no match. Shared by the match badge, the cell, and the count tallies.
export const getMatchType = (preview: BudgetSahPreview): MatchType => {
  if (preview.candidates.length === 0) return 'no-match';
  if (preview.candidates.length === 1) return 'auto';
  return 'choose';
};
